import type { ITaskSheetSection } from '@/interfaces'
import type { ITaskSheetBody } from '@/interfaces/task-sheets/ITaskSheetBody'
import TaskSheetSection from './TaskSheetSection'

class TaskSheetBody implements ITaskSheetBody {
  id?: string

  title: string

  rows: ITaskSheetSection[]

  constructor(taskSheet?: any) {
    this.id = taskSheet?.id
    this.title = taskSheet?.title ?? ''
    this.rows = taskSheet?.rows?.map((section: any) => new TaskSheetSection(section)) ?? []
  }
}

export default TaskSheetBody
